/*
 * @Author: achuang
 * @Date: 2024-09-05 16:47:59
 * @LastEditTime: 2024-09-06 11:28:26
 * @LastEditors: achuang
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/home.vue')
  },
]
console.log(process.env,'process.env.BASE_URL')

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
